import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Fetching from './components/fetching';
import 'bootstrap-icons/font/bootstrap-icons.css';
const App = lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<Fetching />}>
      <App />
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();
